import { CircularProgress, Grid } from '@mui/material';
import { BasicButton } from '@tassat/button';
import axios from 'axios';
import parse from 'html-react-parser';
import React from 'react';

import history from 'Lib/browserHistory';
import { BASE_CLIENT_URL, CORE_SUCCESS_CODE } from 'Lib/constant';
import Worker from 'Lib/worker/PrimusWorker';
import { useAppSelector } from 'Reducers/store/hooks';
import { getUser } from 'Selectors/common';

import type { TermsOfUseProps } from '.';

export function TermsOfUse(props: TermsOfUseProps) {
    const { classes } = props;

    const user = useAppSelector(getUser);
    const [ terms, setTerms ] = React.useState<string>('');
    const [ fetching, setFetching ] = React.useState<boolean>(false);
    const [ termsAccepted, setTermsAccepted ] = React.useState<boolean>(false);
    const [ submitting, setSubmitting ] = React.useState<boolean>(false);

    React.useEffect(() => {
        const fetchTos = async () => {
            try {
                const tosResponse = await axios.get('/clientTos');
                if (tosResponse.status === 200) {
                    setTerms(tosResponse.data);
                    setFetching(false);
                } else throw new Error('Could not get TOS.');
            } catch (err) {
                console.error(err);
            }
        };

        if (!fetching && !terms) {
            setFetching(true);
            fetchTos();
        }
    }, [ fetching, terms ]);

    const toggleAccept = () => setTermsAccepted(!termsAccepted);
    const submitAccept = async () => {
        setSubmitting(true);

        const response = await Worker.getInstance()
            .acceptTermsOfService(user.FirmId, user.UserId, user.Username);

        if (response?.data?.Status === CORE_SUCCESS_CODE) {
            history.replace(BASE_CLIENT_URL);
        } else {
            setSubmitting(false);
        }
    };

    return (
        <Grid
            alignItems='center'
            className={classes.topSection}
            container
            direction='column'
        >
            <Grid
                alignItems='center'
                className={classes.header}
                container
                direction='column'
                item
                justifyContent='flex-start'
                xs={10}
            >
                <p>User Agreement</p>
            </Grid>
            <Grid
                alignItems='center'
                container
                direction='column'
                item
                justifyContent='flex-start'
                xs={10}
            >
                <div className={classes.termsContent}>
                    {terms ?
                        parse(terms)
                        : (
                            <Grid
                                className={classes.progressContainer}
                                container
                                justifyContent='center'
                            >
                                <CircularProgress />
                            </Grid>
                        )}
                </div>
            </Grid>
            <Grid
                alignItems='center'
                className={classes.checkmarkContainer}
                container
                direction='row-reverse'
                justifyContent='center'
            >
                <label htmlFor='tos-checkbox'>Accept Terms of Use</label>
                <input
                    className={`checkmark ${classes.checkmarkInput}`}
                    id='tos-checkbox'
                    onClick={toggleAccept}
                    type='checkbox'
                    value={termsAccepted.toString()}
                />
            </Grid>
            <Grid
                alignItems='center'
                className={classes.buttonContainer}
                container
                direction='row'
                item
                justifyContent='space-around'
                xs={7}
            >
                <BasicButton
                    disabled={!termsAccepted || submitting}
                    onClick={submitAccept}
                    text='Continue'
                    type='mainSlim'
                />
            </Grid>
        </Grid>
    );
}